// @ vendor
const React = require('react');
// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');

const PaymentWithDraftErrorStep = () => {
    const title = formatText('paymentWithDraft-errorTitle');
    const errorSubMessage = <FormattedText value="paymentWithDraft-errorBody" />;
    const url = '/myprofile/taxAndRents';
    const goBackButton = {
        label: formatText('paymentWithDraft-errorBack').toUpperCase(),
        url
    }

    return (
        <article className="payment-with-draft-error row no-gutter">
            <div className="col-xs-offset-2 col-xs-8">
                <WizardError
                    errorMessage={title}
                    errorSubMessage={errorSubMessage}
                    mainButton={goBackButton}
                />
            </div>
        </article>
    )
};

module.exports = PaymentWithDraftErrorStep;
